import { Nullable } from '@Models';

export class OrganisationView {
  name: string;
  logo: Nullable<string>;

  constructor(params: OrganisationViewParams) {
    this.name = params.name;
    this.logo = params.logo ?? null;
  }
}

export type OrganisationViewParams = {
  name: string;
  logo: Nullable<string>;
};
